export default __webpack_public_path__ + "static/media/git.7f887bc0.gif";